import { Box, Container, Typography } from '@mui/material';

import type { PageComponent } from '../../pages.types';

export const Error500Page: PageComponent = () => {
  return (
    <Container data-testid='error500'>
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography variant='display1'>500</Typography>
        <Typography variant='h1'>Внутренняя ошибка сервера.</Typography>
        <Typography variant='h2' sx={{ mt: 2, mb: 4 }}>
          Сервер столкнулся с чем-то неожиданным, что не позволило ему завершить
          запрос.
        </Typography>
      </Box>
    </Container>
  );
};

export default Error500Page;
